import { CoreApplicationContext } from '@eventbrite/context-gen';
import {
    getLocaleOverride,
    getParentLocale,
    setLanguage,
} from '@eventbrite/i18n';
import React from 'react';
import { useCallbackOnce } from './hooks/useCallbackOnce';
import { default as Routes } from './pages/routes';

interface DiscoverAppProps extends CoreApplicationContext {
    history?: History;
    originalContext?: CoreApplicationContext;
}

export default function DiscoverApp(props: DiscoverAppProps) {
    const parentLocale = getParentLocale(
        getLocaleOverride() || props.env.localeInfo.locale,
    );
    useCallbackOnce(() => setLanguage(parentLocale));
    return <Routes {...props} />;
}
